/* ==========================================================================
   Aquí Estamos PY — Cotizador dinámico
   Web Component <ae-cotizador>. El marcado lo genera Liquid (snippets/
   cotizador-panel.liquid); este script maneja el estado, las reglas de
   negocio y los totales.

   Reglas que implementa (única fuente, la comparten el cotizador de
   «A medida», el paso 1 de la reserva y los CTA de los planes):

     · Servicio puntual  → una prestación, sin días de la semana.
     · Plan fijo semanal → uno o varios días de la semana (obligatorio ≥1).
     · 4 horas           → turno mañana o tarde (obligatorio).
     · 6 y 8 horas       → jornada completa, sin turno (se limpia el estado).

   Los precios NO se calculan acá: salen de AE.cotizar (assets/ae-utils.js),
   alimentado por la configuración del tema. El total es por servicio.

   Emite `ae:cotizacion` con la selección completa cada vez que cambia algo.
   ========================================================================== */
(function () {
  'use strict';

  var AE = window.AE || {};

  var DIAS_LARGO = ['', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
  var DIAS_CORTO = ['', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];

  /** Sólo 4 horas admite turno: 6 y 8 cubren mañana y tarde. */
  function admiteTurno(horas) {
    return parseInt(horas, 10) === 4;
  }

  /** Sólo el plan fijo tiene días de la semana. */
  function admiteDias(plan) {
    return plan === 'fijo';
  }

  var proto = {
    /* ------------------------------------------------------ Ciclo de vida */

    connectedCallback: function () {
      if (this._listo) return;
      this._listo = true;

      this.embebido = this.hasAttribute('data-embebido');
      this.destino = this.getAttribute('data-destino') || '/pages/reservar';

      this.estado = {
        plan: this.getAttribute('data-plan-inicial') || 'ocasional',
        horas: parseInt(this.getAttribute('data-horas-inicial'), 10) || 6,
        dias: [],
        turno: '',
        extras: []
      };

      // Precargar desde el cotizador si venimos de allí. Primero la sesión
      // (misma pestaña) y después la URL, que manda porque es explícita y
      // sobrevive a un enlace compartido o a una pestaña nueva.
      if (this.hasAttribute('data-precargar')) {
        var guardado = AE.leerPresupuesto && AE.leerPresupuesto();
        if (guardado) {
          if (guardado.plan) this.estado.plan = guardado.plan;
          if (guardado.horas) this.estado.horas = guardado.horas;
          if (Array.isArray(guardado.dias)) this.estado.dias = guardado.dias.slice();
          if (guardado.turno) this.estado.turno = guardado.turno;
          if (Array.isArray(guardado.extras)) this.estado.extras = guardado.extras.slice();
        }
      }

      this.aplicarParametrosDeUrl();

      this.cachearNodos();
      this.normalizar();
      this.sincronizarControles();
      this.enlazar();
      this.render();
    },

    /* Lee ?plan= ?horas= ?dias= ?turno= ?extras= de la URL. Lo usan las
       tarjetas de planes y el botón del cotizador para llegar a
       /pages/reservar con el servicio ya elegido, sin depender de
       sessionStorage. */
    aplicarParametrosDeUrl: function () {
      if (!window.URLSearchParams) return;

      var q = new URLSearchParams(window.location.search);

      var plan = q.get('plan');
      if (plan === 'fijo' || plan === 'ocasional') this.estado.plan = plan;

      var horas = parseInt(q.get('horas'), 10);
      if (horas === 4 || horas === 6 || horas === 8) this.estado.horas = horas;

      var dias = q.get('dias');
      if (dias !== null) {
        this.estado.dias = dias.split(',')
          .map(function (d) { return parseInt(d, 10); })
          .filter(function (d) { return d >= 1 && d <= 7; });
      }

      var turno = q.get('turno');
      if (turno === 'manana' || turno === 'tarde') this.estado.turno = turno;

      var extras = q.get('extras');
      if (extras !== null) {
        this.estado.extras = extras.split(',').filter(function (id) {
          return id !== '';
        });
      }
    },

    /* Serializa la selección como query string para el enlace de reserva. */
    parametros: function () {
      var q = [
        'plan=' + encodeURIComponent(this.estado.plan),
        'horas=' + encodeURIComponent(this.estado.horas)
      ];
      if (admiteDias(this.estado.plan) && this.estado.dias.length) {
        q.push('dias=' + encodeURIComponent(this.estado.dias.join(',')));
      }
      if (admiteTurno(this.estado.horas) && this.estado.turno) {
        q.push('turno=' + encodeURIComponent(this.estado.turno));
      }
      if (this.estado.extras.length) {
        q.push('extras=' + encodeURIComponent(this.estado.extras.join(',')));
      }
      return q.join('&');
    },

    cachearNodos: function () {
      this.radiosPlan = AE.$$('[data-plan]', this);
      this.radiosHoras = AE.$$('[data-horas]', this);
      this.checksDia = AE.$$('[data-dia]', this);
      this.radiosTurno = AE.$$('[data-turno]', this);
      this.checksExtra = AE.$$('[data-extra]', this);

      this.bloqueDias = AE.$('[data-bloque="dias"]', this);
      this.bloqueTurno = AE.$('[data-bloque="turno"]', this);
      this.opcionesTurno = AE.$('[data-turno-opciones]', this);
      this.nodoJornada = AE.$('[data-jornada]', this);
      this.nodoJornadaHoras = AE.$('[data-jornada-horas]', this);
      this.indicador = AE.$('[data-modalidad-indicador]', this);
      this.nodoAhorroModalidad = AE.$('[data-modalidad-ahorro]', this);

      this.errorDias = AE.$('[data-error-dias]', this);
      this.errorTurno = AE.$('[data-error-turno]', this);

      this.nodoLineas = AE.$('[data-resumen-lineas]', this);
      this.nodoTotal = AE.$('[data-total]', this);
      this.nodoTotalLabel = AE.$('[data-total-label]', this);
      this.nodoAhorro = AE.$('[data-ahorro]', this);
      this.nodoCta = AE.$('[data-cta]', this);
      this.nodoResumenPlan = AE.$('[data-resumen-plan]', this);
      this.nodosNum = AE.$$('[data-num]', this);
    },

    /* ------------------------------------------------- Reglas de negocio */

    /**
     * Deja el estado coherente con las reglas. Se llama después de cualquier
     * cambio para que no queden combinaciones imposibles (por ejemplo un
     * turno elegido con 8 horas, o días sueltos en un servicio puntual).
     */
    normalizar: function () {
      if (!admiteDias(this.estado.plan)) {
        this.estado.dias = [];
      } else {
        var self = this;
        // Un día deshabilitado (domingo, si la tienda no trabaja) no puede
        // quedar seleccionado aunque venga por URL o desde la sesión.
        this.estado.dias = this.estado.dias.filter(function (d) {
          var input = self.inputDia(d);
          return d >= 1 && d <= 7 && !(input && input.disabled);
        }).sort(function (a, b) { return a - b; });
      }

      if (!admiteTurno(this.estado.horas)) this.estado.turno = '';
    },

    inputDia: function (n) {
      for (var i = 0; i < this.checksDia.length; i++) {
        if (parseInt(this.checksDia[i].getAttribute('data-dia'), 10) === n) return this.checksDia[i];
      }
      return null;
    },

    /* ------------------------------------- Estado inicial de los controles */

    sincronizarControles: function () {
      var self = this;

      this.radiosPlan.forEach(function (r) {
        r.checked = r.getAttribute('data-plan') === self.estado.plan;
      });

      this.radiosHoras.forEach(function (r) {
        r.checked = parseInt(r.getAttribute('data-horas'), 10) === self.estado.horas;
      });

      this.checksDia.forEach(function (c) {
        c.checked = self.estado.dias.indexOf(parseInt(c.getAttribute('data-dia'), 10)) > -1;
      });

      this.radiosTurno.forEach(function (r) {
        r.checked = r.getAttribute('data-turno') === self.estado.turno;
      });

      this.checksExtra.forEach(function (c) {
        c.checked = self.estado.extras.indexOf(c.getAttribute('data-extra')) > -1;
      });
    },

    /* --------------------------------------------------------- Eventos */

    enlazar: function () {
      var self = this;

      this.radiosPlan.forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          self.estado.plan = radio.getAttribute('data-plan');
          self.normalizar();
          self.sincronizarControles();
          self.render();
        });
      });

      this.radiosHoras.forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          self.estado.horas = parseInt(radio.getAttribute('data-horas'), 10);
          // Pasar de 4 a 6/8 tiene que borrar el turno: si no, quedaría un
          // «8 horas · Turno mañana» que no significa nada.
          self.normalizar();
          self.sincronizarControles();
          self.render();
        });
      });

      this.checksDia.forEach(function (check) {
        check.addEventListener('change', function () {
          var n = parseInt(check.getAttribute('data-dia'), 10);
          var i = self.estado.dias.indexOf(n);
          if (check.checked && i === -1) self.estado.dias.push(n);
          if (!check.checked && i > -1) self.estado.dias.splice(i, 1);
          self.estado.dias.sort(function (a, b) { return a - b; });
          if (self.estado.dias.length && self.errorDias) self.errorDias.hidden = true;
          self.render();
        });
      });

      this.radiosTurno.forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          self.estado.turno = radio.getAttribute('data-turno');
          if (self.errorTurno) self.errorTurno.hidden = true;
          self.render();
        });
      });

      this.checksExtra.forEach(function (check) {
        check.addEventListener('change', function () {
          var id = check.getAttribute('data-extra');
          var i = self.estado.extras.indexOf(id);
          if (check.checked && i === -1) self.estado.extras.push(id);
          if (!check.checked && i > -1) self.estado.extras.splice(i, 1);
          self.render();
        });
      });

      if (this.nodoCta && !this.embebido) {
        this.nodoCta.addEventListener('click', function (ev) {
          ev.preventDefault();
          // El cotizador suelto no exige completar todo: si falta algo se
          // avisa acá en lugar de mandar una selección incompleta a la
          // reserva, donde el error aparecería sin contexto.
          if (!self.validar()) return;
          AE.guardarPresupuesto(self.serializar());
          var union = self.destino.indexOf('?') > -1 ? '&' : '?';
          window.location.href = self.destino + union + self.parametros();
        });
      }
    },

    /* ------------------------------------------------------ Validación */

    /**
     * Comprueba que la selección esté completa. Marca los avisos y enfoca
     * el primer control que falta.
     * @returns {boolean}
     */
    validar: function () {
      var faltaDias = admiteDias(this.estado.plan) && this.estado.dias.length === 0;
      var faltaTurno = admiteTurno(this.estado.horas) && !this.estado.turno;

      if (this.errorDias) this.errorDias.hidden = !faltaDias;
      if (this.errorTurno) this.errorTurno.hidden = !faltaTurno;
      if (this.bloqueDias) this.bloqueDias.classList.toggle('is-invalid', faltaDias);
      if (this.bloqueTurno) this.bloqueTurno.classList.toggle('is-invalid', faltaTurno);

      var foco = null;
      if (faltaDias) foco = this.checksDia[0];
      else if (faltaTurno) foco = this.radiosTurno[0];

      if (foco) {
        foco.focus({ preventScroll: true });
        var caja = foco.closest('[data-bloque]') || foco;
        caja.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }

      return !faltaDias && !faltaTurno;
    },

    /* ---------------------------------------------------------- Render */

    render: function () {
      var self = this;
      var c = AE.cotizar(this.estado.plan, this.estado.horas, this.estado.extras);
      var conDias = admiteDias(this.estado.plan);
      var conTurno = admiteTurno(this.estado.horas);

      /* ---- Modalidad: precio de entrada y ahorro ---- */
      AE.$$('[data-precio-modalidad]', this).forEach(function (nodo) {
        var plan = nodo.getAttribute('data-precio-modalidad');
        nodo.textContent = AE.gs(AE.precioBase(plan, self.estado.horas));
      });

      if (this.nodoAhorroModalidad) {
        var lista = AE.precioBase('ocasional', this.estado.horas);
        var fijo = AE.precioBase('fijo', this.estado.horas);
        if (lista > fijo && fijo > 0) {
          this.nodoAhorroModalidad.textContent = '−' + Math.round(((lista - fijo) / lista) * 100) + '%';
          this.nodoAhorroModalidad.hidden = false;
        } else {
          this.nodoAhorroModalidad.hidden = true;
        }
      }
      this.moverIndicador();

      /* ---- Precio mostrado en cada opción de horas ---- */
      this.radiosHoras.forEach(function (radio) {
        var h = parseInt(radio.getAttribute('data-horas'), 10);
        var precio = AE.precioBase(self.estado.plan, h);
        var caja = radio.closest('.opt');
        var etiqueta = caja && caja.querySelector('[data-precio-horas]');
        if (etiqueta) etiqueta.textContent = AE.gs(precio);

        // Precio tachado del plan ocasional cuando hay descuento por plan fijo.
        var antes = caja && caja.querySelector('[data-precio-antes]');
        if (antes) {
          var lista = AE.precioBase('ocasional', h);
          if (self.estado.plan === 'fijo' && lista > precio) {
            antes.textContent = AE.gs(lista);
            antes.hidden = false;
          } else {
            antes.hidden = true;
          }
        }
      });

      /* ---- Días: sólo con plan fijo ---- */
      if (this.bloqueDias) {
        this.bloqueDias.hidden = !conDias;
        if (!conDias && this.errorDias) this.errorDias.hidden = true;
        if (!conDias) this.bloqueDias.classList.remove('is-invalid');
      }

      /* ---- Turno: sólo con 4 horas ---- */
      if (this.opcionesTurno) this.opcionesTurno.hidden = !conTurno;
      if (this.nodoJornada) this.nodoJornada.hidden = conTurno;
      if (this.nodoJornadaHoras) this.nodoJornadaHoras.textContent = this.estado.horas;
      this.radiosTurno.forEach(function (r) {
        // Deshabilitado además de oculto: un radio oculto pero activo sigue
        // siendo enfocable con el tabulador.
        r.disabled = !conTurno;
        if (!conTurno) r.checked = false;
      });
      if (!conTurno) {
        if (this.errorTurno) this.errorTurno.hidden = true;
        if (this.bloqueTurno) this.bloqueTurno.classList.remove('is-invalid');
      }

      this.renumerar();

      /* ---- Resumen ---- */
      if (this.nodoResumenPlan) {
        this.nodoResumenPlan.textContent = this.etiquetaPlan();
      }

      if (this.nodoLineas) {
        var html = '<li class="is-base"><span>' + this.estado.horas + ' horas de limpieza</span><b>' + AE.gs(c.base) + '</b></li>';
        c.extras.forEach(function (e) {
          html += '<li><span>+ ' + AE.esc(e.nombre) + '</span><b>' + AE.gs(e.precio) + '</b></li>';
        });
        if (!c.extras.length) {
          html += '<li class="resumen__vacio">Sin servicios adicionales seleccionados</li>';
        }

        // Detalle de lo contratado: días y turno no suman al total, por eso
        // van como notas y no como líneas con importe.
        var notas = '';
        if (conDias) {
          notas += '<li class="resumen__nota"><span>Días</span><b>' +
            (this.estado.dias.length ? AE.esc(this.diasTexto('corto')) : 'Sin elegir') + '</b></li>';
        }
        notas += '<li class="resumen__nota"><span>Turno</span><b>' +
          AE.esc(this.turnoTexto() || 'Sin elegir') + '</b></li>';
        html += notas;

        this.nodoLineas.innerHTML = html;
      }

      if (this.nodoTotal) this.nodoTotal.textContent = AE.gs(c.total);

      // Con varios días por semana el importe sigue siendo el de UN servicio:
      // los precios del tema son por servicio y no se inventa acá un total
      // semanal. El rótulo lo dice para que no se lea como el total del plan.
      if (this.nodoTotalLabel) {
        this.nodoTotalLabel.textContent = (conDias && this.estado.dias.length > 1)
          ? 'Total por servicio'
          : 'Total';
      }

      if (this.nodoAhorro) {
        if (c.ahorro > 0) {
          this.nodoAhorro.hidden = false;
          this.nodoAhorro.innerHTML =
            'Ahorrás <b>' + AE.gs(c.ahorro) + '</b> por servicio (' + c.ahorroPct + '% menos) con el plan fijo semanal.';
        } else {
          this.nodoAhorro.hidden = true;
        }
      }

      this.dispatchEvent(new CustomEvent('ae:cotizacion', {
        bubbles: true,
        detail: this.serializar()
      }));
    },

    /** Numera sólo los bloques visibles: con servicio puntual no hay días. */
    renumerar: function () {
      var n = 0;
      this.nodosNum.forEach(function (nodo) {
        var bloque = nodo.closest('[data-bloque]');
        if (bloque && bloque.hidden) return;
        n += 1;
        nodo.textContent = n;
      });
    },

    /** Corre la barra del selector de modalidad hasta la opción activa. */
    moverIndicador: function () {
      if (!this.indicador) return;
      var activo = null;
      for (var i = 0; i < this.radiosPlan.length; i++) {
        if (this.radiosPlan[i].checked) { activo = this.radiosPlan[i].closest('.modalidad__op'); break; }
      }
      if (!activo || !activo.offsetParent) return;
      this.indicador.style.width = activo.offsetWidth + 'px';
      this.indicador.style.height = activo.offsetHeight + 'px';
      this.indicador.style.transform =
        'translate(' + activo.offsetLeft + 'px,' + activo.offsetTop + 'px)';
      this.indicador.dataset.listo = '1';
    },

    /* ------------------------------------------------------ Etiquetas */

    etiquetaPlan: function () {
      return this.estado.plan === 'fijo' ? 'Plan fijo semanal' : 'Servicio puntual';
    },

    /** [1,3,5] → "Lun · Mié · Vie"  (o los nombres completos). */
    diasTexto: function (formato) {
      var tabla = formato === 'corto' ? DIAS_CORTO : DIAS_LARGO;
      return this.estado.dias.map(function (d) { return tabla[d]; }).join(' · ');
    },

    /** Etiqueta legible del turno, o «Jornada completa» con 6 y 8 horas. */
    turnoTexto: function () {
      if (!admiteTurno(this.estado.horas)) return 'Jornada completa';
      for (var i = 0; i < this.radiosTurno.length; i++) {
        if (this.radiosTurno[i].getAttribute('data-turno') === this.estado.turno) {
          return this.radiosTurno[i].value;
        }
      }
      return '';
    },

    /* ------------------------------------------------------ Serialización */

    serializar: function () {
      var c = AE.cotizar(this.estado.plan, this.estado.horas, this.estado.extras);
      var conDias = admiteDias(this.estado.plan);

      return {
        plan: this.estado.plan,
        planLabel: this.etiquetaPlan(),
        horas: this.estado.horas,
        dias: conDias ? this.estado.dias.slice() : [],
        diasTexto: conDias ? this.diasTexto('largo') : '',
        diasCorto: conDias ? this.diasTexto('corto') : '',
        serviciosPorSemana: conDias ? this.estado.dias.length : 0,
        turno: this.estado.turno,
        turnoLabel: this.turnoTexto(),
        jornadaCompleta: !admiteTurno(this.estado.horas),
        extras: this.estado.extras.slice(),
        extrasDetalle: c.extras.map(function (e) {
          return { id: e.id, nombre: e.nombre, precio: e.precio, variante: e.variante };
        }),
        base: c.base,
        totalExtras: c.totalExtras,
        total: c.total,
        ahorro: c.ahorro,
        completo: (!conDias || this.estado.dias.length > 0) &&
          (!admiteTurno(this.estado.horas) || !!this.estado.turno)
      };
    }
  };

  // Definición del custom element (con soporte para navegadores sin clases ES6).
  if (window.customElements && !window.customElements.get('ae-cotizador')) {
    var El = function () { return Reflect.construct(HTMLElement, [], El); };
    El.prototype = Object.create(HTMLElement.prototype);
    El.prototype.constructor = El;
    Object.assign(El.prototype, proto);
    Object.setPrototypeOf(El, HTMLElement);
    window.customElements.define('ae-cotizador', El);
    window.AE = window.AE || {};
    window.AE.Cotizador = El;
  }

  // La barra del selector se posiciona con medidas reales, así que hay que
  // recalcularla cuando cambia el ancho (las tarjetas pasan de dos columnas
  // a una) o cuando termina de cargar la tipografía.
  window.addEventListener('resize', function () {
    AE.$$('ae-cotizador').forEach(function (c) {
      if (c.moverIndicador) c.moverIndicador();
    });
  });
})();
